document.addEventListener('DOMContentLoaded', function () {
  initAccordionSections();
});

function initAccordionSections() {
  const sections = document.querySelectorAll('.accordionSection');

  sections.forEach((section) => {
    const items = section.querySelectorAll('.accordionSection_item');

    items.forEach((item) => {
      const trigger = item.querySelector('.accordionSection_trigger');
      const content = item.querySelector('.accordionSection_content');

      if (!trigger || !content) return;

      trigger.addEventListener('click', () => {
        const isActive = item.classList.contains('is-active');

        items.forEach((otherItem) => {
          if (otherItem === item) return;
          const otherContent = otherItem.querySelector('.accordionSection_content');
          if (otherContent) collapseItem(otherItem, otherContent);
        });

        if (isActive) {
          collapseItem(item, content);
        } else {
          expandItem(item, content);
        }
      });
    });
  });
}

function expandItem(item, content) {
  item.classList.add('is-active');
  content.style.maxHeight = content.scrollHeight + 'px';
}

function collapseItem(item, content) {
  item.classList.remove('is-active');
  content.style.maxHeight = '0px';
}
